/**
 * AgenticPaymentReferral - Shared Constants
 */

// Pagination
export const ITEMS_PER_PAGE = 20;

// Referral statuses
export const REFERRAL_STATUSES = {
  NOT_ELIGIBLE: 'not_eligible',
  AWAITING_PAYMENT: 'awaiting_payment',
  PAID: 'paid',
  HELD: 'held',
  REJECTED: 'rejected',
};

// Admin page_action endpoints
export const API_ENDPOINTS = {
  DASHBOARD: '/admin/agentic_payment_referral/dashboard',
  LIST: '/admin/agentic_payment_referral/list',
  FIND: (id) => `/admin/agentic_payment_referral/find?id=${id}`,
  PAY: (id) => `/admin/agentic_payment_referral/pay?id=${id}`,
  PAY_ALL: (referrerUserId) => `/admin/agentic_payment_referral/pay_all?referrer_user_id=${referrerUserId}`,
  APPROVE_MONTH: '/admin/agentic_payment_referral/approve_month',
  HOLD: (id) => `/admin/agentic_payment_referral/hold?id=${id}`,
  REJECT: (id) => `/admin/agentic_payment_referral/reject?id=${id}`,
  RELEASE: (id) => `/admin/agentic_payment_referral/release?id=${id}`,
  TRANSACTIONS: (id) => `/admin/agentic_payment_referral/transactions?id=${id}`,
  PAYMENT_HISTORY: '/admin/agentic_payment_referral/payment_history',
  GET_CONFIG: '/admin/agentic_payment_referral/get_config',
  UPDATE_CONFIG: '/admin/agentic_payment_referral/update_config',
};

// Top-level views
export const VIEWS = {
  LIST: 'list',
  PAYMENT_HISTORY: 'payment_history',
  MONTHLY_PAYOUT: 'monthly_payout',
};
